























import { Component, Vue, Prop } from 'vue-property-decorator';
import { IWithoutCert } from './types';
import { ToConfirm } from '@/services';

@Component
export default class WithoutCert extends Vue implements IWithoutCert {
  @Prop({ type: String, default: '' })
  readonly name!: string;

  @Prop({ type: Boolean, default: false })
  readonly needActivate!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isApproved!: boolean;

  @Prop({ type: Object, default: null })
  readonly toConfirm!: ToConfirm;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/certificate/components/withoutcert/WithoutCert.vue